// extracted by mini-css-extract-plugin
export default {"header":"Form_header__2Wtlt","footer":"Form_footer__1X7mw"};